'use strict';
'use es6';

// Turn on [long stack support](https://github.com/kriskowal/q#long-stack-traces)
// for additional Q debug information when running locally

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableLongStackTracesForDev = enableLongStackTracesForDev;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enableLongStackTracesForDev() {
  if (!_enviro2.default.deployed('q')) {
    _q2.default.longStackSupport = true;
  }
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.22/js/longStackTracesForDev.js
// module id = 247
// module chunks = 0